import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { Config } from './config';
import { RestClientService } from './restclient.service';
import { SessaoService } from './sessao.service';
import { CancelamentoProdutosRequest, CancelamentoProdutosResponse, CancelarProdutoRequest, CancelarProdutoResponse } from '../modelo/cancelamento-produtos-response';
import { DadosBancariosCancelamento } from '../bf-cancelarproduto-cli/cancelar-produto-modal-dados-bancarios.component';

@Injectable()
export class CancelamentoProdutosAgregadosService {

    constructor(
        private restClient: RestClientService,
        private sessaoService: SessaoService
    ) { }

    /**
     * Busca os produtos agregados dos contratos fornecidos
     * @param contratos - Lista de números de contratos
     * @returns Observable com os contratos e seus produtos agregados
     */
    buscarProdutosAgregados(contratos: string[]): Observable<CancelamentoProdutosResponse> {
        let resourcePath = Config.SERVIDOR + Config.LIQUIDACAOANTECIPADA_WS + "/cancelamento-produtos-agregados";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        resourcePath += "/api/v1/contratos";
        
        const requestBody: CancelamentoProdutosRequest = {
            contratos: contratos
        };
        
        return this.restClient.postResource(resourcePath, requestBody).map(response => response as CancelamentoProdutosResponse);
    }

    /**
     * Cancela um produto agregado específico
     * @param numeroContrato - Número do contrato
     * @param codigoProduto - Código do produto a ser cancelado
     * @param dadosBancarios - Dados bancários informados pelo usuário (banco, agência e conta)
     * @returns Observable com a resposta do cancelamento
     */
    cancelarProduto(numeroContrato: string, codigoProduto: string, dadosBancarios: DadosBancariosCancelamento): Observable<CancelarProdutoResponse> {
        let resourcePath = Config.SERVIDOR + Config.LIQUIDACAOANTECIPADA_WS + "/cancelamento-produtos-agregados";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        resourcePath += "/api/v1/contratos-produtos-agregados";

        const autenticado = this.sessaoService.sessao.autenticado;
        // usa nuCpfCnpjFormatado (sempre atualizado pelo endpoint de contratos) e remove a máscara,
        // pois nuCpfCnpj pode estar desatualizado/incompleto na sessão
        const cpfCnpjOrigem = autenticado.nuCpfCnpjFormatado || autenticado.nuCpfCnpj || '';

        const requestBody: CancelarProdutoRequest = {
            contrato: Number(numeroContrato),
            cdProdutoServico: Number(codigoProduto),
            cpfCnpj: cpfCnpjOrigem.replace(/[^\dA-Za-z]/g, ''),
            cdBanco: dadosBancarios.cdBanco,
            nuAgencia: dadosBancarios.dsAgencia,
            nuConta: dadosBancarios.dsConta.replace('-', ''),
            tpConta: dadosBancarios.tpConta,
            dsEmail: dadosBancarios.dsEmail
        };

        return this.restClient.postResource(resourcePath, requestBody);
    }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/services/cancelamento-produtos-agregados.service.ts